// extracted by mini-css-extract-plugin
module.exports = {"item":"Resizer_item__1GYyA","resizer":"Resizer_resizer__1mC41","disabled":"Resizer_disabled__2ou2o"};